import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Breadcrumb
}from 'react-bootstrap'

import Collapsible from '../collapsible'

@observer(['globals'])
export default class Permissions extends Component {

  constructor(props) {
    super(props)

    this.props.globals.setCurrentSubPage('permissions')
  }

  render() {
    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
              <Breadcrumb>
                <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Permissions</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          <Collapsible title="Permissions" content="Coming Soon" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/permissions.js